$('article.project figure').hover(function() {

})